import { PagedQuery } from '../core';
/**
 * Requests a list of all court systems
 */
export class ListCourtSystemsQuery extends PagedQuery {
    constructor(page) {
        super(page);
    }
}
